import { InfoIcon } from 'lucide-react'

import { getChainConfigEntry } from '@/config/chain'
import { UseNetworkChangeResult } from '@/features/dialogs/select-network/logic/useNetworkChange'
import { Button } from '@/ui/atoms/button/Button'

export interface ChainMismatchViewProps {
  expectedChainId: number
  currentChainId: number
  networkChange: UseNetworkChangeResult
}

export function ChainMismatchView({ expectedChainId, currentChainId, networkChange }: ChainMismatchViewProps) {
  const expectedChainConfig = getChainConfigEntry(expectedChainId)
  const currentChainConfig = getChainConfigEntry(currentChainId)

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1 md:gap-0.5">
        <InfoIcon className="icon-size-md md:icon-size-xs icon-tertiary" />
        <div className="typography-body-4 text-secondary">
          You're trying to execute actions on {expectedChainConfig.meta.name} but you're currently connected to{' '}
          {currentChainConfig.meta.name}.
        </div>
      </div>
      <Button onClick={() => networkChange.changeNetwork(expectedChainId)} loading={networkChange.isPending}>
        Switch to {expectedChainConfig.meta.name}
      </Button>
      {networkChange.error && (
        <div className="typography-body-4 text-system-error-primary">{networkChange.error.message}</div>
      )}
    </div>
  )
}
